/**
 * FleetMap — camadas de tile padrão (fonte única).
 * Mapa Escuro (CARTO) / Mapa Padrão (OSM) / Satélite Esri (default).
 * Extraído de DashboardPage (ADR-2026-05-29-shared-fleetmap-component).
 */

import React from 'react';
import { TileLayer, LayersControl } from 'react-leaflet';

const { BaseLayer } = LayersControl;

const FleetTileLayers = ({ defaultLayer = 'satellite' }) => (
  <LayersControl position="topright">
    <BaseLayer checked={defaultLayer === 'dark'} name="Mapa Escuro">
      <TileLayer attribution="&copy; CARTO" url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />
    </BaseLayer>
    <BaseLayer checked={defaultLayer === 'standard'} name="Mapa Padrao">
      <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    </BaseLayer>
    <BaseLayer checked={defaultLayer === 'satellite'} name="Satelite">
      <TileLayer attribution="&copy; Esri" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
    </BaseLayer>
  </LayersControl>
);

export default FleetTileLayers;
